<template>
    <div class="landing grid-layout">
        <div class="nameslist">
            <v-greeting-title></v-greeting-title>
            <v-add-person-to-list></v-add-person-to-list>
            <v-person-list></v-person-list>
        </div>
        <div class="kyan-animatie">
            <v-kyan-animatie v-if="isBigScreen"></v-kyan-animatie>
        </div>
        <div class="current-speaker">
            <v-speaker-card></v-speaker-card>
        </div>
        <div class="brandlogo">
            <img src="/static/img/mrynklogo.svg" alt="Logo van Mr. Ynk.">
        </div>
    </div>
</template>

<style lang="scss"></style>

<script>
    import PersonList from '@/app/components/PersonList';
    import KyanAnimatie from '@/app/components/KyanAnimatie';
    import SpeakerCard from '@/app/components/SpeakerCard';

    import GreetingTitle from '@/app/components/GreetingTitle';
    import AddPersonToList from '@/app/components/AddPersonToList';

    import { AppState } from '@/app/data';

    export default {
        components: {
            'v-greeting-title': GreetingTitle,
            'v-add-person-to-list': AddPersonToList,
            'v-person-list': PersonList,
            'v-kyan-animatie': KyanAnimatie,
            'v-speaker-card': SpeakerCard
        },

        data()
        {
            return {
                isBigScreen: false
            };
        },

        computed: {
            findActiveSpeaker()
            {
                return this.$store.getters['people/findActiveSpeaker'];
            },

            hasBegun()
            {
                return this.$store.getters.hasBegun;
            }
        },

        mounted()
        {
            window.addEventListener( 'keyup', this.spacebarFunction.bind( this ) );

            window.addEventListener( 'resize', this.checkWindowWidth.bind( this ) );
            this.checkWindowWidth();
        },

        methods: {
            spacebarFunction( e )
            {
                if( e.code === 'Space' )
                {
                    if( this.$store.getters.currentStatus === AppState.READY && document.activeElement.tagName !== 'INPUT' )
                    {
                        this.$store.dispatch( 'people/pickRandomSpeaker' );
                        this.$store.dispatch( 'people/finishSpeakerRound', this.findActiveSpeaker );
                    }
                }
            },

            checkWindowWidth()
            {
                window.innerWidth > 1250 ? this.isBigScreen = true : this.isBigScreen = false;
            }
        }
    };
</script>
